import React, { useEffect, useRef } from "react";
import { injectAndExecuteScript } from "../../../../../common/helpers/scriptInjector";

interface PaymentFormProps {
  /** The raw HTML content (script/iframe) provided by Iyzico */
  iyzicoHtmlContent?: string;

  /** The PayTR token for the iframe source */
  paytrToken?: string;

  /** The ID of the container div that the gateway script expects to find in the DOM. */
  containerId?: string;
}

const PaymentForm: React.FC<PaymentFormProps> = ({
  iyzicoHtmlContent,
  paytrToken,
  containerId,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  // --- IYZICO LOGIC (HTML Injection) ---
  useEffect(() => {
    if (iyzicoHtmlContent && containerRef.current) {
      // Clear container before injecting
      containerRef.current.innerHTML = "";
      // Inject and execute the initialization script
      injectAndExecuteScript(iyzicoHtmlContent, containerRef.current);
    }

    return () => {
      // Cleanup for Iyzico
      if (iyzicoHtmlContent && containerRef.current) {
        containerRef.current.innerHTML = "";
      }
      // @ts-ignore
      if (window.iyziInit) {
        // @ts-ignore
        window.iyziInit = undefined;
      }
    };
  }, [iyzicoHtmlContent]);

  // --- PAYTR LOGIC (iFrame + Resizer) ---
  useEffect(() => {
    if (paytrToken) {
      // 1. Load the resizer script if not present
      if (!document.getElementById("paytr-resizer-script")) {
        const script = document.createElement("script");
        script.id = "paytr-resizer-script";
        script.src = "https://www.paytr.com/js/iframeResizer.min.js";
        script.async = true;
        script.onload = () => {
          // 2. Initialize resize once loaded
          if (window.iFrameResize) {
            window.iFrameResize({}, "#paytriframe");
          }
        };
        document.body.appendChild(script);
      } else {
        // Script already exists, just init if ready
        if (window.iFrameResize) {
          window.iFrameResize({}, "#paytriframe");
        }
      }
    }
  }, [paytrToken]);

  // --- Render Logic ---

  if (paytrToken) {
    return (
      <div className="payment-form-wrapper payment-form-wrapper--paytr">
        <iframe
          src={`https://www.paytr.com/odeme/guvenli/${paytrToken}`}
          id="paytriframe"
          frameBorder="0"
          scrolling="no"
          style={{ width: "100%", minHeight: "600px" }}
        ></iframe>
      </div>
    );
  }

  // Fallback / Iyzico
  return (
    <div className="payment-form-wrapper">
      <div id={containerId} className="responsive"></div>
      <div ref={containerRef} style={{ display: "none" }}></div>
    </div>
  );
};

export default PaymentForm;
